import React from "react";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function ErrorMessage({ message }) {
  if (!message) {
    return <></>;
  }
  return (
    <span className="flex items-center text-sm text-red-600">
      <ErrorOutlineIcon style={{fontSize:16}}/>
      &nbsp;
      {message}
    </span>
  );
}
